<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row v-if=" creatable">
              <b-col cols="8">
                <h3>
                  Các đáp án cho câu hỏi <strong><u>{{ roleName }}</u></strong>
                </h3>
              </b-col>
              <b-col cols="4">
                <div class="text-right">
                  <b-button
                    v-if="creatable && resources.length === 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.addMultipleChoiceAnswerModal
                    variant="success"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Thêm câu trả lời
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row :class="{'mt-2': creatable}">
              <b-col cols="12">
                <vue-good-table
                  mode="remote"
                  :columns="columns"
                  :rows="resources"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  :line-numbers="true"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span
                      v-if="props.column.field === 'isCorrect'"
                      :class="props.row.isCorrect !== 1 ? 'text-danger':'text-success font-weight-bolder'"
                      v-html="getIsCorrect(props.row.isCorrect)"
                    />
                    <span
                      v-else-if="props.column.field === 'multiple'"
                      :class="props.row.multiple !== 1 ? 'text-danger':'text-success font-weight-bolder'"
                      v-html="getIsCorrect(props.row.multiple)"
                    />
                    <span v-else-if="props.column.field === 'action'">
                      <b-button
                        variant="primary"
                        v-b-modal.editModal
                        class="btn-icon"
                        size="sm"
                        @click="onEditResource(props.row)"
                      >
                        <feather-icon icon="Edit2Icon" />
                      </b-button>
                      <b-button
                        variant="danger"
                        class="btn-icon ml-1"
                        size="sm"
                        @click="onDeleteResource(props.row)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị 1 đến </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap">của {{ resources.length }} bản ghi</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <AddMultipleChoiceAnswerResource
      :qb-question-id="selectedId"
      @succeed="onSucceed"
    />
    <EditMultipleChoiceAnswer
      :data-form="currentDataSource"
      @succeed="onSucceed"
    />
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton, BCard, BCol, BContainer, BFormSelect, BOverlay, BPagination, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import '@core/scss/vue/libs/vue-good-table.scss'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import AddMultipleChoiceAnswerResource
from '@/views/exam-question/qb-multiple-choice-answer/AddMultipleChoiceAnswerResource.vue'
import { STATUS_SYMBOLS } from '@/const/status'
import EditMultipleChoiceAnswer from '@/views/exam-question/qb-multiple-choice-answer/EditMultipleChoiceAnswer.vue'

export default {
  name: 'MultipleChoiceAnswerResource',
  directives: {
    Ripple,
  },
  props: {
    qbQuestionId: {
      type: Number,
      default: null,
    },
  },
  components: {
    AddMultipleChoiceAnswerResource,
    EditMultipleChoiceAnswer,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        qbQuestionId: this.qbQuestionId,
        sort: null,
      },
      currentResource: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      selectedId: this.qbQuestionId,
      roleName: '',
      currentDataSource: undefined
    }
  },
  computed: {
    ...mapGetters({
      resources: 'qbMultipleChoiceAnswer/dataSources',
      totalRows: 'qbMultipleChoiceAnswer/totalRows',
    }),
    columns() {
      let data = [
        {
          label: 'Tên đáp án',
          field: 'name',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Nội dung',
          field: 'content',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Là đáp án đúng',
          field: 'isCorrect',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Câu hỏi có nhiều đáp án',
          field: 'multiple',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
      if (this.deletable) {
        data = [...data, {
          label: '',
          field: 'action',
          sortable: false,
          tdClass: 'text-center',
        }]
      }
      return data
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.QB_MULTIPLE_CHOICE_ANSWER)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.QB_MULTIPLE_CHOICE_ANSWER)
    },
  },
  async created() {
    this.isLoading = true
    try {
      await Promise.all([
        this.getResources({
          params: this.filter,
        }),
      ])
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    isSystemAdmin,
    ...mapActions({
      getResources: 'qbMultipleChoiceAnswer/getResources',
      deleteResource: 'qbMultipleChoiceAnswer/delete',
    }),
    onEditResource(dataSource) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = dataSource
      this.currentDataSource = rest
    },
    onDeleteResource(resource) {
      this.$swal({
        title: 'Bạn chắc chắn muốn xóa dữ liệu?',
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteResource({
              id: resource.id,
            })
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.getResources({
                    params: this.filter,
                  })
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    getIsCorrect(id) {
      return STATUS_SYMBOLS.find(status => status.value === id).label
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getResourcesFromStore()
    },
    async getResourcesFromStore() {
      this.isLoading = true
      try {
        await this.getResources({
          params: this.filter,
        })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getResourcesFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        switch (field) {
          case 'name':
            this.updateParams({ sort: `1_${type}` })
            break
          case 'content':
            this.updateParams({ sort: `2_${type}` })
            break
          case 'score':
            this.updateParams({ sort: `3_${type}` })
            break
          default:
            this.updateParams({ sort: `4_${type}` })
            break
        }
        await this.getResourcesFromStore()
      }
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'content')) this.updateParams({ content: columnFilters.content })
      if (Object.hasOwn(columnFilters, 'score')) this.updateParams({ score: columnFilters.score })
      await this.getResourcesFromStore()
    },
    async onSucceed() {
      await this.getResourcesFromStore()
    },
  },
}
</script>
